import { Deserializable } from '../protocols/deserializable';
import { AccountType } from './account-type';

export class Account implements Deserializable {
  public id!: number;
  public typeId!: number;
  public type!: AccountType;
  public memberId!: number;
  public member!: string;
  public employerId!: number;
  public employer!: string;
  public financialBalance!: number;
  public active!: boolean;
  public comment!: string;
  public createdDate!: string;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.type) {
      this.type = Deserialize?.instanceOf(AccountType, this.type);
    }
  }
}
